// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"38":"63447384","189":"601f613a","282":"50a12dd5","573":"157366e9","667":"dd134aeb","941":"546eae0c"}[chunkId] + ".chunk.js";
};